import React, { memo, useRef } from "react";
import animations from "../animations/animations";
import {
  Wrapper,
  DropdownCreditsContainer,
  CreditsHeading,
  Container,
  ContentCredits,
  Category,
  Link,
  Content,
  Title,
  Name,
  Chevron,
} from "../styles/components/footer";

const CreditsText = ({ category, title, name, link, creditsColor }) => (
  <>
    {!!category && <Category $creditsColor={creditsColor}>{category}</Category>}
    <Content>
      <Title $creditsColor={creditsColor}>
        {title}:{" "}
        {(!link && <Name $creditsColor={creditsColor}>{name}</Name>) || (
          <Link
            href={link}
            target="_blank"
            rel="noreferrer"
            $creditsColor={creditsColor}
          >
            <Name $creditsColor={creditsColor}>{name}</Name>
          </Link>
        )}
      </Title>
    </Content>
  </>
);

const Credits = ({ creditsComponent, colors }) => {
  const { creditsTexts, creditsColor } = creditsComponent;
  const { primary } = colors || {};

  const wrapperRef = useRef(null);
  const containerDropdownRef = useRef(null);
  const containerContentRef = useRef(null);

  const showCredits = () => {
    if (typeof window === "undefined") return;
    animations
      .timeline()
      .to(
        containerDropdownRef.current,
        { opacity: 0, display: "none", duration: 0 },
        "<"
      )
      .to(
        containerContentRef.current,
        {
          maxHeight: `${containerContentRef.current.scrollHeight}px`,
          duration: 0.5,
        },
        "<"
      );
  };

  return (
    <Wrapper ref={wrapperRef}>
      <DropdownCreditsContainer
        ref={containerDropdownRef}
        role="button"
        tabIndex={0}
        onClick={showCredits}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            showCredits();
          }
        }}
        aria-expanded="false"
        aria-controls="credits-panel"
        $creditsColor={creditsColor?.hex || creditsColor || primary}
      >
        <CreditsHeading
          $creditsColor={creditsColor?.hex || creditsColor || primary}
        >
          Credits
        </CreditsHeading>
        <Chevron
          viewBox="0 0 32 32"
          aria-hidden="true"
          focusable="false"
          $creditsColor={creditsColor?.hex || creditsColor || primary}
        >
          <path
            strokeWidth="2"
            d="M15 6.667L28.333 20 15 33.333"
            vectorEffect="non-scaling-stroke"
          ></path>
        </Chevron>
      </DropdownCreditsContainer>
      <ContentCredits>
        <Container
          ref={containerContentRef}
          id="credits-panel"
          role="region"
          aria-label="Credits information"
        >
          {creditsTexts.map(creditsText => (
            <CreditsText
              key={creditsText.id}
              category={creditsText.category}
              name={creditsText.name}
              title={creditsText.title}
              link={creditsText.link}
              creditsColor={creditsColor?.hex || creditsColor || primary}
            />
          ))}
        </Container>
      </ContentCredits>
    </Wrapper>
  );
};

export default memo(Credits);
